export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

export const isUUID = (str) => {
  const regex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  return regex.test(str)
}

/**
 * Converts a hyphenated status identifier to a human-readable title case label.
 * Hyphens are replaced by spaces and each word is capitalized.
 *
 * @param {string|null|undefined} identifier - The status identifier to format.
 * @returns {string} The formatted label, empty string for null/undefined, or
 *   the raw identifier as fallback if formatting fails.
 *
 * @example
 * formatStatusIdentifier('customer-closure') // "Customer Closure"
 * formatStatusIdentifier('active')           // "Active"
 * formatStatusIdentifier(null)               // ""
 */
export const formatStatusIdentifier = (identifier) => {
  if (identifier == null || identifier === '') return ''

  try {
    return String(identifier)
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  } catch {
    return String(identifier)
  }
}
